function  HandleHeaderAnchorClick( event )
{
    if( event.currentTarget.classList.contains( "lightning-header-anchor-desktop") )
    {
        var searchContainer = document.querySelector( ".bridgman-header-search-desktop" );
    }
    else
    {
        var searchContainer = document.querySelector( ".bridgman-header-search-mobile" );
    }
    
    if( searchContainer.classList.contains( "hidden" ) )
    {
        searchContainer.classList.remove( "hidden" );
    }
    else
    {
        searchContainer.classList.add( "hidden" );
    }
}

function CloseHeaderDesktopSearch( event )
{
    var searchContainer = event.currentTarget.closest( ".bridgman-header-search" );
    
    if( searchContainer.classList.contains( "hidden" ) )
    {
        searchContainer.classList.remove( "hidden" );
    }
    else
    {
        searchContainer.classList.add( "hidden" );
    }
}

function handleMobHeaderHeight( )
{
    var mobNavBar   = document.getElementById( "mobileNavBar" );
    mobNavBarHeight = mobNavBar.offsetHeight;
    var announcementBars = document.getElementsByClassName( "bridgman-announcement-bar-container" )
    if( announcementBars.length > 0 )
    {
        var announcementHeight = announcementBars[0].offsetHeight;
    }
    var topRowHeader = document.querySelector( ".bridgman-header-top-container" );
    
    if ( topRowHeader ) 
    {
        if( window.innerWidth <= 480 )
        {
            if( announcementHeight )
            {
                topRowHeader.style.marginTop = ( mobNavBarHeight + announcementHeight ) + "px";
            }
            else
            {
                topRowHeader.style.marginTop = mobNavBarHeight + "px";
            }
        }
        else
        {
            topRowHeader.style.marginTop = "0px";
        }
    }
}

window.addEventListener( "DOMContentLoaded", function( e )
{
    $( '.lightning-header-anchor' ).on( "click", function( event )
    {
        HandleHeaderAnchorClick( event );
    } );
    $( '.bridgman-header-search-desktop-close-button' ).on( 'click', function( event )
    {
        CloseHeaderDesktopSearch( event );
    } );
} );

window.addEventListener( "load", function( e )
{
    handleMobHeaderHeight();
} );

window.addEventListener( "resize", function( e )
{
    handleMobHeaderHeight();
} );